export const providers = '/providers/:view?'
export const benchmarks = '/benchmarks/:view?'
export const providersExisting = '/providers-existing/:view?'
export const resourceExplorer = '/resource/:resourceType/:resourceId/:activeTabParam?/:view?/:requestTemplateId?'
export const contacts = '/resources/contacts'
export const subscriptions = '/resources/subscriptions'
export const dataHubCollection = '/datahub/:view/:viewType?'
export const transparency = '/transparency'
export const solutionSelector = '/'
export const dashboard = '/dashboard'
export const sourcingDashboard = '/sourcing/dashboard'
export const sourcingStartDashboard = '/sourcing/dashboard/start'
export const investmentDashboard = '/investment/dashboard'
export const financeDashboard = '/esgreport/dashboard'
export const transparencyDashboard = '/transparency/dashboard'
export const transparencyBaselineAssessment = '/transparency/baseline-assessment/:id'
export const transparencyStandardAssessment = '/transparency/standard-assessment/:id'
export const transparencyProviderProgress = '/transparency/dashboard/progress'
export const transparencySustainabilityProfile = '/transparency/sustainability-profile'
export const configurations = '/configurations/:configurationsPage?/:configurationsSubPage?'
export const sustainabilityLibrary =
  '/sustainability-library/:configurationsPage?/:configurationsSubPage?/:activeTabParam?/:activeTabSubId?'
export const evaluations = '/evaluations'
export const providerRisk = '/provider-risk'
export const notifications = '/notifications'
export const request = '/request/:flow/:requestId'
export const response = '/response/:flow/:responseId'

export const productsCollection = '/product-mapping/products'
export const productDueDiligence = '/product-mapping/products/due-diligence'
export const createProduct = '/product-mapping/products/create'
export const product = '/product-mapping/products/:id?'
export const mappingNodeCollection = '/product-mapping/value-chains'
export const receivedMappingRequestCollection = '/product-mapping/received-requests'
export const mappingRequest = '/product-mapping/received-requests/:id'
export const sentMappingRequestCollection = '/product-mapping/sent-requests'
export const receivedMappingResponseCollection = '/product-mapping/responses'
export const productMappingCompanies = '/product-mapping/companies'
export const productMappingContacts = '/product-mapping/contacts'

export const logout = '/logout/:sso?'
export const userSettings = '/user/:page?'
export const co2eCalculator = '/co2e-calculator'
export const engagedProviders = '/engaged-providers'
export const editTemplate = '/template-builder/:templateId?'
export const questionnaireBuilderCustomQuestion = '/questionnaire-builder/question/:questionId?'
export const questionCollection = '/resources/questions'

export const reporting = '/reporting'
export const productReporting = '/reporting/product'
export const yourData = '/your-data'
export const legacySustainabilityProfile = '/sustainability-profile'

export const manageRequest = '/manage/:view?'
export const riskScreening = '/risk-screening/:view?'

export const baselineAssessment = '/base-assessment/:view?'
export const providerBaselineAssessmentWithId = '/resource/supplier/:supplierId/assessments'
export const assessments = '/assessments/:view?/:assessmentTemplateId?'
export const allAssessments = '/all-assessments/:view?'
export const assessmentTemplateCollection = '/sustainability-library/assessments'

export const insightsReport = '/sustainability-report/insights-report'
export const supplyChainDueDiligenceStatement = '/sustainability-report/supply-chain-due-diligence-statement'

export const topicalRisk = '/topical-risk/:view?'
export const sourcingExpectationsList = '/expectations'
export const sourcingExpectation = '/expectations/:id'
export const sourcingExpectationProvider = '/expectations/:id/:expectationId'
export const findings = '/findings/:view?'

export const recommendedJourney = '/recommended-journey'
export const sourcingRecommendation = '/sourcing-recommendation/:view?'

export const platformReleases = '/platform-releases'

export const transparencyExpectationList = sourcingExpectationsList
export const transparencyExpectation = sourcingExpectation

const paths = {
  resourceExplorer,
  providers,
  providersExisting,
  benchmarks,
  contacts,
  logout,
  request,
  response,
  dataHubCollection,
  configurations,
  sustainabilityLibrary,
  evaluations,
  solutionSelector,
  dashboard,
  sourcingDashboard,
  sourcingStartDashboard,
  investmentDashboard,
  financeDashboard,
  notifications,
  userSettings,
  transparency,
  transparencyDashboard,
  transparencyBaselineAssessment,
  transparencyStandardAssessment,
  subscriptions,
  co2eCalculator,
  engagedProviders,
  reporting,
  productReporting,
  editTemplate,
  productsCollection,
  productDueDiligence,
  createProduct,
  product,
  valueChainCollection: mappingNodeCollection,
  mappingRequestCollection: receivedMappingRequestCollection,
  mappingRequest,
  mappingNodeCollection,
  sentMappingRequestCollection,
  receivedMappingResponseCollection,
  productMappingCompanies,
  productMappingContacts,
  manageRequest,
  yourData,
  legacySustainabilityProfile,
  transparencyProviderProgress,
  transparencySustainabilityProfile,
  providerRisk,
  questionCollection,
  riskScreening,
  questionnaireBuilderCustomQuestion,
  providerBaselineAssessmentWithId,
  assessments,
  allAssessments,
  assessmentTemplateCollection,
  insightsReport,
  supplyChainDueDiligenceStatement,
  topicalRisk,
  sourcingExpectationsList,
  sourcingExpectation,
  sourcingExpectationProvider,
  transparencyExpectationList,
  transparencyExpectation,
  findings,
  recommendedJourney,
  sourcingRecommendation,
  platformReleases,
}

export default paths
